import { Injectable } from '@angular/core';
import { Effect, ofType, Actions } from '@ngrx/effects';
import {
  getWebsitesAction,
  getWebsitesSuccessAction,
  getWebsitesFailAction,
  getAccountsAction,
  getAccountsSuccessAction,
  getAccountsFailAction,
  upsertWebsiteSuccessAction,
  upsertWebsiteAction,
  upsertWebsiteFailAction,
  deleteWebsiteAction,
  deleteWebsiteSuccessAction,
  deleteWebsiteFailAction,
} from './ecom.actions';
import { switchMap, map, catchError } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable()
export class EcomEffects {
  @Effect()
  getWebsites$ = this.actions$.pipe(
    ofType(getWebsitesAction),
    switchMap(() =>
      this.ecomService.getWebsites().pipe(
        map((response) => getWebsitesSuccessAction({ websites: response })),
        catchError(() => {
          this.toastr.error('Could not fetch websites', 'Request failed');
          return [getWebsitesFailAction()];
        }),
      ),
    ),
  );

  @Effect()
  upsertWebsite$ = this.actions$.pipe(
    ofType(upsertWebsiteAction),
    switchMap((action) => {
      return this.ecomService.upsertWebsite(action.payload).pipe(
        switchMap(() => {
          this.toastr.success('Website successfully saved');
          this.router.navigate(['../', { relativeTo: this.route }]);
          return [upsertWebsiteSuccessAction(), getWebsitesAction()];
        }),
        catchError((response) => {
          this.toastr.error(
            JSON.stringify(response.error, null, 4),
            'Could not update website',
          );
          return [upsertWebsiteFailAction()];
        }),
      );
    }),
  );

  @Effect()
  deleteWebsite$ = this.actions$.pipe(
    ofType(deleteWebsiteAction),
    switchMap((action) => {
      return this.ecomService.deleteWebsite(action.payload).pipe(
        switchMap(() => {
          this.toastr.success('Website successfully deleted');
          this.router.navigate(['../', { relativeTo: this.route }]);
          return [deleteWebsiteSuccessAction(), getWebsitesAction()];
        }),
        catchError(() => {
          this.toastr.error('Could not update website', 'Request failed');
          return [deleteWebsiteFailAction()];
        }),
      );
    }),
  );

  @Effect()
  getAccounts$ = this.actions$.pipe(
    ofType(getAccountsAction),
    switchMap(() =>
      this.ecomService.getAccounts().pipe(
        map((response) => getAccountsSuccessAction({ accounts: response })),
        catchError(() => {
          this.toastr.error('Could not fetch accounts', 'Request failed');
          return [getAccountsFailAction()];
        }),
      ),
    ),
  );

  constructor(
    private readonly actions$: Actions,
    private readonly toastr: ToastrService,
    private readonly ecomService: ApiService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
  ) {}
}
